import * as $ from "jquery";
import * as _ from "lodash";
import { BaseSettingsView } from "./_BaseSettingsView";
import { UserCollection } from "../../collections/Users";
import { PointOfContactCollection } from "../../collections/PointsOfContact";
import { Intercom } from "../../common/intercom";
import { TimezoneCollection } from "../../collections/Timezones";

var template = require('templates/settings/installation.html');

require('bootstrap-toggle');
require('bootstrap-slider');


function toTime(v) {
    var hour = Math.floor(v / 60);
    var minutes = (v % 60);
    var ampm = ' AM';
    if (hour > 11 && hour < 24) ampm = ' PM';

    if (hour < 1) {
        hour += 12;
    } else if (hour > 12) {
        hour -= 12;
    }

    return hour + ':' + (minutes === 0 ? '00' : minutes) + ampm;
}
function updateSliderText(elem, val, on) {
    var text = on ? toTime(val[0]) + ' - ' + toTime(val[1]) : '';
    elem.text(text);
}

export class InstallationView extends BaseSettingsView {

    template = _.template(template);

    userCollection: UserCollection = null;
    pocCollection: PointOfContactCollection = null;
    collectionLoaded: boolean = false;
    saved: boolean = false;

    constructor(options) {
        super(<any>_.extend(options, {
            el: '#settings-main-subview',
            events: {
                'submit .settings-installation-form': 'handleSave',
                'change .settings-installation-form-property-cost-gas-unit': 'handleGasUnitChange',

                // Handle Points of Contact Events
                'click .settings-installation-form-add-poc': 'handleAddPointOfContact',
                'change .settings-installation-form-poc': 'handlePOCSelectChange',
                'click .settings-installation-form-remove-poc-row': 'handleRemovePointOfContact',
                'click .coordinates-btn': 'handleGenerateCoordinates'
            }
        }));
    }

    setErrors(errors?) {
        var selector = this.$('.settings-installation-form-errors');
        if (!errors) return selector.addClass('hidden');

        selector.find('ul').html(_.map(errors, (e) => { return '<li>' + _.escape(e) + '</li>' }).join(''));
        selector.removeClass('hidden');
    }

    async handleSave() {
        this.setErrors();

        var installName = (<string>this.$('.settings-installation-form-name').val()).trim();
        var squareFeet = (<string>this.$('.settings-installation-form-size').val()).trim();
        var timezone = (<string>this.$('.settings-installation-form-timezone').val());
        var propertyName = (<string>this.$('.settings-installation-form-property-name').val()).trim();
        var address = (<string>this.$('.settings-installation-form-property-address').val()).trim();
        var address2 = (<string>this.$('.settings-installation-form-property-address-2').val()).trim();
        var city = (<string>this.$('.settings-installation-form-property-address-city').val()).trim();
        var state = (<string>this.$('.settings-installation-form-property-address-state').val()).trim();
        var zip = (<string>this.$('.settings-installation-form-property-address-zip').val()).trim();

        let latitude = (<string>this.$('.settings-installation-form-property-address-latitude').val()).trim();
        if (!latitude.length) latitude = null;
        let longitude = (<string>this.$('.settings-installation-form-property-address-longitude').val()).trim();
        if (!longitude.length) longitude = null;

        var electricity = (<string>this.$('.settings-installation-form-property-cost-electricity').val()).trim();
        var gas = (<string>this.$('.settings-installation-form-property-cost-gas').val()).trim();
        var gasUnit = (<string>this.$('.settings-installation-form-property-cost-gas-unit').val());
        var gasFactor = (<string>this.$('.settings-installation-form-property-cost-gas-factor').val()).trim();
        var water = (<string>this.$('.settings-installation-form-property-cost-water').val()).trim();

        var weekdayOpHours = (<any>this.$('.settings-installation-form-property-hours-weekday')).slider('getValue');
        var weekdayOpen = this.$('.settings-installation-form-property-hours-weekday-open').prop('checked');
        var saturdayOpHours = (<any>this.$('.settings-installation-form-property-hours-saturday')).slider('getValue');
        var saturdayOpen = this.$('.settings-installation-form-property-hours-saturday-open').prop('checked');
        var sundayOpHours = (<any>this.$('.settings-installation-form-property-hours-sunday')).slider('getValue');
        var sundayOpen = this.$('.settings-installation-form-property-hours-sunday-open').prop('checked');

        var errors = [];
        if (installName.length === 0) errors.push('Installation Name may not be empty');
        if (address2.length && !address.length) errors.push('Installation Address may not be empty');
        if (address.length) {
            if (!city.length) errors.push('City may not be empty');
            if (!state.length) errors.push('State may not be empty');
            if (!zip.length) errors.push('Zip Code may not be empty');
        }
        if (zip.length && (zip.length < 4 || zip.length > 12)) {
            errors.push('Zip Code must be between 4 and 12 characters');
        }

        var squareFeetNum = Number(squareFeet);
        if (squareFeet.length) {
            if (_.isNaN(squareFeetNum)) {
                errors.push('Installation Size is not valid');
            } else if (squareFeetNum > 9999999999 || squareFeetNum < 0) {
                errors.push('Installation Size must be between 999,999 and 0 square feet');
            }
        } else {
            squareFeetNum = null;
        }
        if (electricity.length && isNaN(Number(electricity))) errors.push('Average Electricity Rate is not valid');
        if (gas.length && isNaN(Number(gas))) errors.push('Average Gas Rate is not valid');
        if (gasFactor.length && isNaN(Number(gasFactor))) errors.push('Gas Conversion Factor is not valid');
        if (water.length && isNaN(Number(water))) errors.push('Average Water Rate is not valid');

        if (errors.length) return this.setErrors(errors);

        if (!propertyName) propertyName = null;
        if (!address) address = null;
        if (!address2) address2 = null;
        if (!state) state = null;
        if (!zip) zip = null;

        var electricityNum = electricity.length ? Number(electricity) : null;
        var waterNum = water.length ? Number(water) : null;

        var gasNum = Number(gas);
        if (!gas.length) {
            gasNum = null;
        } else {
            if (gasUnit === 'btu') {
                gasNum /= 100000;
            } else if (gasUnit === 'ccf') {
                gasNum *= Number(gasFactor);
            }
        }

        var requestData = {
            organization_install_name: installName,
            timezone: timezone,
            property_name: propertyName,
            property_address: address,
            property_address_2: address2,
            property_address_city: city,
            property_address_state: state,
            property_address_zip: zip,
            property_geo_latitude: latitude,
            property_geo_longitude: longitude,
            property_avg_cost_electricity: electricityNum,
            property_avg_cost_gas: gasNum,
            property_avg_cost_water: waterNum,
            property_sqft: squareFeetNum,
            property_hours_start_weekday: weekdayOpen ? weekdayOpHours[0] : null,
            property_hours_end_weekday: weekdayOpen ? weekdayOpHours[1] : null,
            property_hours_start_saturday: saturdayOpen ? saturdayOpHours[0] : null,
            property_hours_end_saturday: saturdayOpen ? saturdayOpHours[1] : null,
            property_hours_start_sunday: sundayOpen ? sundayOpHours[0] : null,
            property_hours_end_sunday: sundayOpen ? sundayOpHours[1] : null
        };
        var pocIds = _.filter(_.map(
            this.$('.settings-installation-form-poc'), (p) => { return Number($(p).val()) }
        ), (id) => { return Boolean(id) });

        this.collectionLoaded = false;
        this.render();

        $.when(
            $.ajax({
                type: "PUT",
                url: window.location.origin + '/api/v1/organizations/' + this.options.orgId + '/installs/' + this.options.installId,
                data: JSON.stringify(requestData),
                dataType: 'json',
                contentType: "application/json; charset=utf-8"
            })
        ).then(() => {
            return $.ajax({
                type: "PUT",
                url: this.pocCollection.url(),
                data: JSON.stringify(pocIds),
                dataType: 'json',
                contentType: "application/json; charset=utf-8"
            })
        }).done(() => {
            $.when(
                this.options.installCollection.fetch(),
            ).done(() => {
                this.show();
                window['App'].Bus.trigger('rerender:nav');
            });

            Intercom.trackEvent('changed-settings-installation', {
                install_id: this.options.installId,
                module_id: this.options.moduleId
            });
        });
    }

    show() {
        this.render();

        var deferreds = [];

        if (this.options.orgId && this.options.permissionCollection.canViewOrganization(this.options.orgId)) {
            this.userCollection = new UserCollection([], { organizationId: this.options.orgId });
            deferreds.push(this.userCollection.fetch());
        }

        if (this.options.orgId && this.options.permissionCollection.canViewInstall(this.options.installId)) {
            this.pocCollection = new PointOfContactCollection([], {
                organizationId: this.options.orgId,
                installId: this.options.installId
            });
            deferreds.push(this.pocCollection.fetch());
        }

        $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();

            if (this.pocCollection) this.pocCollection.each((poc) => {
                var e = this.handleAddPointOfContact();
                e.find('option[value="' + poc.get('user_id') + '"]').prop('selected', true);
                e.find('select').trigger('change');
            });
        });
    }

    render() {
        this.$el.html(this.template({
            permissionCollection: this.options.permissionCollection,
            install: this.options.installCollection.getOrgInstall(this.options.installId, this.options.orgId),
            currentOrgId: this.options.orgId,
            currentInstallId: this.options.installId,
            collectionLoaded: this.collectionLoaded,
            saved: this.saved,
            timezones: new TimezoneCollection()
        }));

        if (this.collectionLoaded) {
            // Make checkboxes a toggle switch
            (<any>this.$('.settings-installation-form [data-toggle="toggle"]')).bootstrapToggle();
            this.$('.settings-installation-form input[data-toggle="toggle"]').change((e) => {
                var enabled = $(e.currentTarget).prop('checked');
                var slider = <any>$(e.currentTarget).parents('.form-group').find('.settings-installation-form-slider');
                var text = $(e.currentTarget).parents('.form-group').find('.settings-installation-form-slider-text');
                slider.slider(enabled ? 'enable' : 'disable');
                updateSliderText(text, slider.slider('getValue'), enabled);
            });

            // Setup sliders
            (<any>this.$('.settings-installation-form [data-slider="slider"]')).slider();
            this.$('.settings-installation-form [data-slider="slider"]').on('slide', (e) => {
                updateSliderText(
                    $(e.currentTarget).parents('.form-group').find('.settings-installation-form-slider-text'),
                    (<any>e).value, true
                );
            });
            _.each(this.$('.settings-installation-form [data-slider="slider"]'), (e) => {
                var enabled = $(e).parents('.form-group').find('input[data-toggle="toggle"]').prop('checked');
                updateSliderText(
                    $(e).parents('.form-group').find('.settings-installation-form-slider-text'),
                    (<any>$(e)).slider('getValue'), enabled
                );
            });
        }

        return this;
    }

    getPointOfContactOption(user) {
        var u = _.escape(user.get('name'));
        if (user.get('company_role')) u += ' &lt;' + _.escape(user.get('company_role')) + '&gt;';
        return '<option value="' + _.escape(user.get('id')) + '">' + u + '</option>';
    }

    handleAddPointOfContact() {
        var canEdit = this.options.permissionCollection.canModifyInstall(this.options.installId);
        var currentIds = _.map(this.$('.settings-installation-form-poc'), (p) => { return Number($(p).val()) });

        var e = '<div class="settings-installation-form-poc-row">' +
            '<div class="col-sm-10 settings-installation-form-select-poc-row">' +
            '<select class="form-control settings-installation-form-poc " ' + (!canEdit ? ' disabled' : '') + '>' +
            '<option value="">Please Select</option>';

        this.userCollection.each((user) => {
            if (_.includes(currentIds, user.get('id'))) return;
            e += this.getPointOfContactOption(user);
        });

        e += '</select></div>';
        if (canEdit) {
            e += '' +
                '<div class="col-sm-2 clickable settings-installation-form-remove-poc-row">' +
                '<p class="form-control-static">' +
                '<i class="fa fa-trash"></i>' +
                '</p>' +
                '</div>';
        }
        e += '</div>';

        var $e = $(<string>e);
        this.$('.settings-installation-form-add-poc-row').before($e);
        this.checkHideAddPointOfContact();
        this.delegateEvents();
        return $e;
    }

    checkHideAddPointOfContact() {
        var currentIds = _.map(this.$('.settings-installation-form-poc'), (p) => { return Number($(p).val()) });

        if (currentIds.length === this.userCollection.length) {
            this.$('.settings-installation-form-add-poc-row').addClass('hidden');
        } else {
            this.$('.settings-installation-form-add-poc-row').removeClass('hidden');
        }
    }

    handleGasUnitChange(e: JQuery.UIEventBase) {
        var unit = $(e.currentTarget).val();

        if (unit === 'ccf') {
            this.$('.settings-installation-form-property-cost-gas-factor-row').removeClass('hidden');
        } else {
            this.$('.settings-installation-form-property-cost-gas-factor-row').addClass('hidden');
        }
    }

    handlePOCSelectChange(e: JQuery.UIEventBase) {
        var currentTarget = $(e.currentTarget);
        var currentId = currentTarget.val();

        var currentIds = _.map(this.$('.settings-installation-form-poc'), (p) => { return Number($(p).val()) });
        var allSelects = this.$('.settings-installation-form-poc');

        _.each(allSelects, (s) => {
            var select = $(s);

            if (currentId && !select.is(currentTarget)) {
                var option = select.find('option[value="' + currentId + '"]');
                if (option.length) option.remove();
            }

            this.userCollection.each((user) => {
                var id = user.get('id');
                var option = select.find('option[value="' + id + '"]');

                if (!option.length && !_.includes(currentIds, id)) {
                    select.append(this.getPointOfContactOption(user));
                }
            });
        });
    }

    handleRemovePointOfContact(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents('.settings-installation-form-poc-row').remove();
        $('.settings-installation-form-poc').eq(0).trigger('change');

        this.checkHideAddPointOfContact();
    }


    async handleGenerateCoordinates() {
        const address = (<string>this.$('.settings-installation-form-property-address').val()).trim();
        const address2 = (<string>this.$('.settings-installation-form-property-address-2').val()).trim();
        const city = (<string>this.$('.settings-installation-form-property-address-city').val()).trim();
        const state = (<string>this.$('.settings-installation-form-property-address-state').val()).trim();
        const zip = (<string>this.$('.settings-installation-form-property-address-zip').val()).trim();

        // Notify the user if any of the address fields are missing
        if (!address || !city || !state || !zip) {
            this.notifyUser('Missing Address', 'Please fill the Address, City, State and Zip Code fields before generating coordinates.', 'warning');
            return;
        }

        //Fetch cordinates
        let coordinates;
        const fullAddress = `${address}, ${city} ${state} ${zip}`;
        try {
            coordinates = await this.fetchCoordinates(fullAddress);
        } catch (err) {
            this.notifyUser('Unexpected error', 'Unable to populate coordinates, please try again later.', 'warning');
            return;
        }

        // Format coordinates to use five decimal points
        const latitude = (coordinates.latitude).toFixed(5);
        const longitude = (coordinates.longitude).toFixed(5);
        //Notify user and populate inputs with results
        this.notifyUser('Coordinates generated', `We found your coordinates for ${coordinates.formatted_address}`, 'success');
        this.$('.settings-installation-form-property-address-latitude').val(latitude);
        this.$('.settings-installation-form-property-address-longitude').val(longitude);
    }

    fetchCoordinates(address) {
        const geocoderUrl = `${window.location.origin}/api/v1/geocoder`;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: `${geocoderUrl}?address=${encodeURIComponent(address)}`,
                headers: {
                    'X-Tenant-ID': `${this.options.orgId}`,
                },
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                success: (response) => {
                    resolve(response);

                    return;
                },
                error: (err) => {
                    reject(err);
                    return;
                }
            });
        });
    }

    notifyUser(title, message, type) {
        let alertType;
        switch (type) {
            case 'warning':
                alertType = "warning-alt"
                break;
            case 'success':
                alertType = "success-alt"
                break;
            default:
                alertType = "default-alt"
                break;
        }

        (<any>$).notify({
            title: title,
            message: message,
            icon: type === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle',
        }, {
            animate: {
                enter: 'animated fadeInUp',
            },
            // The type property defines the css style
            // See alerts.less for available styles
            type: alertType,
            placement: { from: "bottom", align: "center" }
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/InstallationView.ts